export default {
    addListener: () => { },
    removeListeners: () => { },
};
//# sourceMappingURL=NotificationPresenterModule.js.map